function toggleVisibility(el: HTMLElement, action: "show" | "hide") {
    if (action === "show") {
        el.setAttribute("aria-hidden", "false");
        el.classList.remove("hidden");
    } else if (action === "hide") {
        el.setAttribute("aria-hidden", "true");
        el.classList.add("hidden");
    }
}

export function show(el: HTMLElement) {
    toggleVisibility(el, "show");
}

export function hide(el: HTMLElement) {
    toggleVisibility(el, "hide");
}